const {
    isEmpty, trim, replace, find, toLower, map,
} = require('lodash');

const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'September',
    'August',
    'October',
    'November',
    'December',
];

class ReviewService {
    constructor(restangular) {
        this._api = restangular.one('Product/Review');
    }

    getOrdinalSuffix(date) {
        const dayOfMonth = date.getDate();
        const dayNumber = dayOfMonth % 10;

        if (dayNumber === 1 && dayOfMonth !== 11) {
            return `${dayOfMonth}st`;
        }
        if (dayNumber === 2 && dayOfMonth !== 12) {
            return `${dayOfMonth}nd`;
        }
        if (dayNumber === 3 && dayOfMonth !== 13) {
            return `${dayOfMonth}rd`;
        }

        return `${dayOfMonth}th`;
    }

    getScreenReaderDate(date) {
        date = new Date(date);
        return `the ${this.getOrdinalSuffix(date)} of ${months[date.getMonth()]}, ${date.getFullYear()}`;
    }

    getFirstCharacter(name) {
        return !isEmpty(name) ? name[0] : '';
    }

    getHtmlContent(body) {
        if (isEmpty(trim(body))) return '';
        return replace(body, /<[^>]+>/g, '');
    }

    getReviewSource(reviewSource, source) {
        if (!reviewSource || !source) return '';
        const sourceText = find(reviewSource, { key: trim(toLower(source)) });
        return sourceText.value || '';
    }

    mapItems(reviews) {
        return map(reviews, r => ({
            Body: r.Body,
            ScreenReaderCreatedDate: this.getScreenReaderDate(r.CreatedDate),
            IsoCreatedDate: new Date(r.CreatedDate).toISOString().slice(0, 10),
            CreatedDate: new Date(r.CreatedDate).toLocaleDateString('en-AU'),
            Member: r.Member,
            Rating: r.Rating,
            Source: r.Source,
        }));
    }

    getReviews(stockcode, pageNumber, pageSize, sortType) {
        return this._api.get({
            stockcode,
            pageNumber,
            pageSize,
            sortType,
        }).then((response => ({
            items: this.mapItems(response.Reviews),
            totalRecordCount: response.TotalCount,
        })));
    }
}

ReviewService.$inject = ['Restangular'];

module.exports = { ReviewService };



// WEBPACK FOOTER //
// ./src/shop/review/review.service.js